import { Button } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";

const NavbarButton = ({ icon, content, to }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = location.pathname === to;
    return (
        <Button
            leftIcon={icon}
            colorScheme="teal"
            border={"none"}
            bg={isActive ? "teal" : "none"}
            variant={isActive ? "solid" : "outline"}
            w={"100%"}
            justifyContent={"flex-start"}
            onClick={() => navigate(to)}
        >
            {content}
        </Button>
    );
};

export default NavbarButton;
